import React, { useEffect, useMemo, useState } from "react"; // eslint-disable-line no-unused-vars

import { graphql } from "gatsby";
import { Loadable } from "@loadable/component";
import type { HeadFC, PageProps } from "gatsby";
import { ListItem } from "../components/common/ListItem";
import { SEO } from "../components/navigation/Seo";
import { shuffle } from "../utils/common";
import { TagPage } from "../components/pagelayout/Tags/TagPage";
import * as lazyStyles from "../styles/pages/Loader.module.scss";
import classNames from "classnames";

export const query = graphql`
  query TagTemplate($slug: String!) {
    students: allMongodbAcrossrca2223Students(
      filter: { tags: { elemMatch: { slug: { eq: $slug } } } }
    ) {
      edges {
        node {
          id
          displayName
          slug
          statements {
            text
            type
            alt
            cloudinary {
              gatsbyImageData
            }
            image
          }
          tags {
            text
            slug
          }
        }
      }
    }
    projects: allMongodbAcrossrca2223Projects(
      filter: { tags: { elemMatch: { slug: { eq: $slug } } } }
    ) {
      edges {
        node {
          id
          displayName
          slug
          statements {
            text
            type
            cloudinary {
              gatsbyImageData(width: 1920)
            }
            image
            alt
          }
          tags {
            text
            slug
          }
        }
      }
    }
  }
`;

// const LazyTagPage = Loadable(
//   async () => (await import("../components/pagelayout/Tags/TagPage")).TagPage,
//   {
//     fallback: (
//       <>
//         <div className={lazyStyles.loader}>
//           <div>Loading...</div>
//         </div>
//       </>
//     ),
//   },
// );

const TagTemplate = ({ data, pageContext }) => {
  const { students, projects } = data;

  const studentTags = students?.edges?.flatMap(({ node }) => {
    const studentAbout = node?.statements?.find(
      (statement) => statement?.type === "biography",
    );
    const image = studentAbout?.cloudinary?.gatsbyImageData;

    return {
      label: "Student",
      itemSlug: node.slug,
      displayName: node.displayName,
      image: image,
      tags: node.tags,
      alt: node.displayName,
      to: `/students/${node.slug}`,
    };
  });

  const projectTags = projects?.edges?.flatMap(({ node }) => {
    const projectAbout = node?.statements?.find(
      (statement) => statement?.type === "about",
    );
    const image = projectAbout?.cloudinary?.gatsbyImageData;
    return {
      label: "Project",
      itemSlug: node.slug,
      displayName: node.displayName,
      image: image,
      tags: node.tags,
      alt: node.displayName,
      to: `/projects/${node.slug}`,
    };
  });

  const allTags = shuffle([...studentTags, ...projectTags]);

  return (
    <>
      <ListItem
        to={`/tags`}
        icon="arrow-left"
        topBorder={false}
        leftBorder={false}
        rightBorder={false}
        bottomBorder={false}
        size="navigation"
        reverse
        justifyContent="flex-end"
      >
        Tags
      </ListItem>
      <TagPage tagItems={allTags} title={pageContext.text} />
      {/* <h2>students</h2>
      {students.edges.map(({ node }, index) => {
        return (
          <div key={index}>
            <p>{node.displayName}</p>
          </div>
        );
      })}
      <h2>projects</h2>
      {projects.edges.map(({ node }, index) => {
        return (
          <div key={index}>
            <p>{node.displayName}</p>
          </div>
        );
      })} */}

      {/* <TagPage
        tag={tag}
      /> */}
    </>
  );
};

export default TagTemplate;

export const Head = ({ data }: PageProps<TagTemplateQuery>) => {
  const studentAbout = data.student?.statements?.find(
    (statement) => statement?.type === "biography",
  );

  const student = data.student;

  const seoImage = studentAbout?.image || "/social.jpg";

  const seoDescription = studentAbout?.text
    ?.replace(/(<([^>]+)>)/gi, "")
    .replace(/&nbsp;/g, "");

  const studentTitle = student?.displayName || "Student";

  return (
    <SEO title={studentTitle} description={seoDescription} image={seoImage} />
  );
};
